export default "__VITE_ASSET__CDRKBB6P__"